import React from 'react';
import FormattedText from '../../../components/01_atoms/FormattedText';
import { generateClassNameByBehaviorSettings } from '../../../utils/behaviorSettings';
import { DefaultPictureType } from '../../../types';
import Picture from '../../../components/01_atoms/DefaultPicture';
import { BehaviourSettingsType } from '../../../utils/behaviorSettings/prop-types';

import styles from './index.module.scss';

type Props = {
  title?: string;
  text: string;
  image: DefaultPictureType;
  style: 'default' | 'christmas';
  behaviorSettings?: BehaviourSettingsType;
  uuid?: string;
};

const BBTextImageWithTitle = ({
  title = '',
  text,
  image,
  style = 'default',
  behaviorSettings,
  uuid,
}: Props) => {
  const classes = [
    'bb',
    styles['bb-text-image-with-title'],
    styles[`bb-text-image-with-title--${style}`],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')} id={uuid}>
      <div className="container">
        <div className={styles['bb-text-image-with-title__root']}>
          <div className={styles['bb-text-image-with-title__main']}>
            {!!title && (
              <FormattedText
                tag="h2"
                text={title}
                className={styles['bb-text-image-with-title__title']}
              />
            )}
            <FormattedText text={text} className={styles['bb-text-image-with-title__text']} />
          </div>
          <div className={styles['bb-text-image-with-title__image']}>
            <Picture {...image} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BBTextImageWithTitle;
